// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3k_ho","text":"styles__text___1G0Ph","title":"styles__title___3xpX9","image":"styles__image___12Bbp"};